var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.params.status == 'success')?_c('p',[_vm._v("Płatność została zrealizowana.")]):_c('p',[_vm._v("Płatność nie została zrealizowana.")]),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'runner-payments', params: {id: _vm.$route.params.id}}}},[_vm._v("Powrót do listy płatności")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b810e7f2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/payments/RunnerPaymentReturn.vue
// module id = 551
// module chunks = 2